import type { TransitionStatus } from 'react-transition-group';

export const isEntering = (state: TransitionStatus): boolean => state === 'entering';
export const isEntered = (state: TransitionStatus): boolean => state === 'entered';
export const isExiting = (state: TransitionStatus): boolean => state === 'exiting';
export const isExited = (state: TransitionStatus): boolean => state === 'exited';
export const isEnter = (state: TransitionStatus): boolean => isEntering(state) || isEntered(state);
